import { usePageSpaceId } from '@confluence/page-context';
import { useSpaceId } from '@confluence/space-utils/entry-points/useSpaceId.ts';

/**
 * The space ID the editor should use. An Access Link viewer is not a member of the page's space, so
 * `SpaceIdentifiersQuery` is denied and `useSpaceId()` returns undefined. The share token's own query
 * has already resolved the space and supplies it through page state, so prefer that when present.
 *
 * This is context, not permission: the ID grants no access to the space and must not be read as
 * proof of any.
 */
export const useEditorSpaceId = (): string | undefined => {
	const [pageSpaceId] = usePageSpaceId();
	const spaceId = useSpaceId();

	return pageSpaceId ?? spaceId;
};
